import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {

  private hideHeaderMenu: boolean = false;

  get hideHeader(): boolean {
    return this.hideHeaderMenu;
  }

  set hideHeader(value: boolean) {
    this.hideHeaderMenu = value;
  }

  /**
   * Method: change value hideHeaderMenu
   * @param show
   */
  changeHideHeaderMenu(show: boolean): void {
    this.hideHeader = show;
  }

}
